import React, { memo } from 'react';
import { Globe, BarChart2, Palette, Zap } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <Globe className="w-12 h-12 text-blue-600 mb-4" data-id="element-131" />,
    title: 'Diseño y desarrollo web',
    description: 'Creamos sitios web atractivos y funcionales con WordPress, Shopify, Tienda Nube y tecnologías personalizadas.'
  }, {
    icon: <BarChart2 className="w-12 h-12 text-blue-600 mb-4" data-id="element-132" />,
    title: 'Publicidad en redes sociales',
    description: 'Gestionamos campañas efectivas en Meta Ads, TikTok Ads y Google Ads para maximizar tu retorno de inversión.'
  }, {
    icon: <Palette className="w-12 h-12 text-blue-600 mb-4" data-id="element-133" />,
    title: 'Branding y diseño gráfico',
    description: 'Desarrollamos identidades visuales memorables que conectan con tu audiencia y fortalecen tu presencia en el mercado.'
  }, {
    icon: <Zap className="w-12 h-12 text-blue-600 mb-4" data-id="element-134" />,
    title: 'Automatizaciones y embudos',
    description: 'Implementamos sistemas automatizados y embudos de venta que optimizan la conversión y aumentan tus ingresos.'
  }];
  return <section id="services" className="py-16 md:py-24 bg-white" data-id="element-135">
      <div className="container mx-auto px-4" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900" data-id="element-138">
            Nuestros Servicios
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-139">
            Soluciones digitales completas para impulsar el crecimiento de tu
            negocio.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-140">
          {services.map((service, index) => <div key={index} className="bg-gray-50 p-8 rounded-lg transition-all duration-300 hover:shadow-md text-center" data-id="element-141">
              <div className="flex justify-center" data-id="element-142">{service.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-gray-900" data-id="element-143">
                {service.title}
              </h3>
              <p className="text-gray-700" data-id="element-144">{service.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}